import { useMutation, useQueryClient } from '@tanstack/react-query';
import sportsApi from '../../../utils/sportsApi';
import { CommonKey } from '../../../types/api';

const useUpdateCampaign = ({
    clientId,
    id,
}: {
    clientId: number;
    id: string;
}) => {
    const queryClient = useQueryClient();

    const updateCampaign = async (domainObject: any) => {
        const payload = {
            domainObject: domainObject,
        };

        return await sportsApi
            .url(`/clients/${clientId}/social-campaigns/${id}`)
            .json(payload)
            .put()
            .json();
    };

    const mutation = useMutation({
        mutationFn: updateCampaign,
        onSuccess: data => {
            queryClient.setQueryData(
                [CommonKey.Campaigns, clientId],
                (oldData: any) => {
                    // Ensure oldData is an array, default to empty array if not
                    const existingData = Array.isArray(oldData) ? oldData : [];
                    const campaigns = existingData.map((campaign: any) => {
                        if (campaign.id === id) {
                            return {
                                ...campaign,
                                ...(typeof data === 'object' && data !== null
                                    ? data
                                    : {}),
                            };
                        }
                        return campaign;
                    });
                    return campaigns;
                },
            );
        },
    });

    return mutation;
};

export default useUpdateCampaign;
